import React, { useState, useEffect, useCallback } from 'react';

const TreatmentTimelineTreatments = ({ patientId, onCountUpdate, componentName }) => {
  const [selectedTreatment, setSelectedTreatment] = useState('oncology');
  const [treatments, setTreatments] = useState({});
  const [loading, setLoading] = useState(true);

  // Función para cargar datos
  const loadData = useCallback(async () => {
    try {
      setLoading(true);
      // Simular carga de datos desde API
      const response = await fetch(`/api/treatments/timeline/${patientId}`);
      const result = await response.json();
      
      // Si no hay datos de la API, usar datos mock como fallback
      const treatmentsData = result || {
        oncology: {
          name: 'Oncology Treatment',
          timeline: [
            {
              id: 1,
              type: 'Surgery',
              status: 'In Progress',
              statusColor: 'warning',
              dateRange: '01/09/2021 - 30/09/2021',
              doctor: 'Dr Sara Wilson'
            },
            {
              id: 2,
              type: 'Therapy',
              status: 'In Progress',
              statusColor: 'success',
              dateRange: '01/09/2021 - 30/09/2021',
              doctor: 'Dr Sara Wilson'
            },
            {
              id: 3,
              type: 'Surgery',
              status: 'In Progress',
              statusColor: 'warning',
              dateRange: '01/09/2021 - 30/09/2021',
              doctor: 'Dr Sara Wilson'
            },
            {
              id: 4,
              type: 'Therapy',
              status: 'In Progress',
              statusColor: 'success',
              dateRange: '01/09/2021 - 30/09/2021',
              doctor: 'Dr Sara Wilson'
            },
            {
              id: 5,
              type: 'Surgery',
              status: 'In Progress',
              statusColor: 'warning',
              dateRange: '01/09/2021 - 30/09/2021',
              doctor: 'Dr Sara Wilson'
            }
          ]
        },
        cardiology: {
          name: 'Cardiology Treatment',
          timeline: [
            {
              id: 1,
              type: 'Consultation',
              status: 'Completed',
              statusColor: 'success',
              dateRange: '15/08/2021 - 15/08/2021',
              doctor: 'Dr Michael Johnson'
            },
            {
              id: 2,
              type: 'Surgery',
              status: 'In Progress',
              statusColor: 'warning',
              dateRange: '20/08/2021 - 25/08/2021',
              doctor: 'Dr Michael Johnson'
            },
            {
              id: 3,
              type: 'Recovery',
              status: 'Scheduled',
              statusColor: 'secondary',
              dateRange: '26/08/2021 - 15/09/2021',
              doctor: 'Dr Michael Johnson'
            }
          ]
        },
        orthopedics: {
          name: 'Orthopedic Treatment',
          timeline: [
            {
              id: 1,
              type: 'X-Ray',
              status: 'Completed',
              statusColor: 'success',
              dateRange: '10/07/2021 - 10/07/2021',
              doctor: 'Dr Lisa Chen'
            },
            {
              id: 2,
              type: 'Physical Therapy',
              status: 'In Progress',
              statusColor: 'success',
              dateRange: '15/07/2021 - 15/10/2021',
              doctor: 'Dr Lisa Chen'
            },
            {
              id: 3,
              type: 'Surgery',
              status: 'Scheduled',
              statusColor: 'secondary',
              dateRange: '20/10/2021 - 22/10/2021',
              doctor: 'Dr Lisa Chen'
            },
            {
              id: 4,
              type: 'Rehabilitation',
              status: 'Scheduled',
              statusColor: 'secondary',
              dateRange: '25/10/2021 - 25/12/2021',
              doctor: 'Dr Lisa Chen'
            }
          ]
        },
        dermatology: {
          name: 'Dermatology Treatment',
          timeline: [
            {
              id: 1,
              type: 'Consultation',
              status: 'Completed',
              statusColor: 'success',
              dateRange: '05/06/2021 - 05/06/2021',
              doctor: 'Dr Amanda Rodriguez'
            },
            {
              id: 2,
              type: 'Biopsy',
              status: 'Completed',
              statusColor: 'success',
              dateRange: '12/06/2021 - 12/06/2021',
              doctor: 'Dr Amanda Rodriguez'
            },
            {
              id: 3,
              type: 'Laser Treatment',
              status: 'In Progress',
              statusColor: 'warning',
              dateRange: '20/06/2021 - 30/08/2021',
              doctor: 'Dr Amanda Rodriguez'
            },
            {
              id: 4,
              type: 'Follow-up',
              status: 'Scheduled',
              statusColor: 'secondary',
              dateRange: '15/09/2021 - 15/09/2021',
              doctor: 'Dr Amanda Rodriguez'
            },
            {
              id: 5,
              type: 'Topical Treatment',
              status: 'In Progress',
              statusColor: 'success',
              dateRange: '01/07/2021 - 30/10/2021',
              doctor: 'Dr Amanda Rodriguez'
            },
            {
              id: 6,
              type: 'Final Assessment',
              status: 'Scheduled',
              statusColor: 'secondary',
              dateRange: '15/11/2021 - 15/11/2021',
              doctor: 'Dr Amanda Rodriguez'
            }
          ]
        }
      };

      setTreatments(treatmentsData);
      
    } catch (error) {
      console.error('Error loading treatment timeline data:', error);
      // En caso de error, usar datos mock
      setTreatments(getMockData());
    } finally {
      setLoading(false);
    }
  }, [patientId]);

  // Función para obtener datos mock
  const getMockData = () => ({
    oncology: {
          name: 'Oncology Treatment',
          timeline: [
            {
              id: 1,
              type: 'Surgery',
              status: 'In Progress',
              statusColor: 'warning',
              dateRange: '01/09/2021 - 30/09/2021',
              doctor: 'Dr Sara Wilson'
            },
            {
              id: 2,
              type: 'Therapy',
              status: 'In Progress',
              statusColor: 'success',
              dateRange: '01/09/2021 - 30/09/2021',
              doctor: 'Dr Sara Wilson'
            },
            {
              id: 3,
              type: 'Surgery',
              status: 'In Progress',
              statusColor: 'warning',
              dateRange: '01/09/2021 - 30/09/2021',
              doctor: 'Dr Sara Wilson'
            },
            {
              id: 4,
              type: 'Therapy',
              status: 'In Progress',
              statusColor: 'success',
              dateRange: '01/09/2021 - 30/09/2021',
              doctor: 'Dr Sara Wilson'
            },
            {
              id: 5,
              type: 'Surgery',
              status: 'In Progress',
              statusColor: 'warning',
              dateRange: '01/09/2021 - 30/09/2021',
              doctor: 'Dr Sara Wilson'
            }
          ]
        },
        cardiology: {
          name: 'Cardiology Treatment',
          timeline: [
            {
              id: 1,
              type: 'Consultation',
              status: 'Completed',
              statusColor: 'success',
              dateRange: '15/08/2021 - 15/08/2021',
              doctor: 'Dr Michael Johnson'
            },
            {
              id: 2,
              type: 'Surgery',
              status: 'In Progress',
              statusColor: 'warning',
              dateRange: '20/08/2021 - 25/08/2021',
              doctor: 'Dr Michael Johnson'
            },
            {
              id: 3,
              type: 'Recovery',
              status: 'Scheduled',
              statusColor: 'secondary',
              dateRange: '26/08/2021 - 15/09/2021',
              doctor: 'Dr Michael Johnson'
            }
          ]
        },
        orthopedics: {
          name: 'Orthopedic Treatment',
          timeline: [
            {
              id: 1,
              type: 'X-Ray',
              status: 'Completed',
              statusColor: 'success',
              dateRange: '10/07/2021 - 10/07/2021',
              doctor: 'Dr Lisa Chen'
            },
            {
              id: 2,
              type: 'Physical Therapy',
              status: 'In Progress',
              statusColor: 'success',
              dateRange: '15/07/2021 - 15/10/2021',
              doctor: 'Dr Lisa Chen'
            },
            {
              id: 3,
              type: 'Surgery',
              status: 'Scheduled',
              statusColor: 'secondary',
              dateRange: '20/10/2021 - 22/10/2021',
              doctor: 'Dr Lisa Chen'
            },
            {
              id: 4,
              type: 'Rehabilitation',
              status: 'Scheduled',
              statusColor: 'secondary',
              dateRange: '25/10/2021 - 25/12/2021',
              doctor: 'Dr Lisa Chen'
            }
          ]
        },
        dermatology: {
          name: 'Dermatology Treatment',
          timeline: [
            {
              id: 1,
              type: 'Consultation',
              status: 'Completed',
              statusColor: 'success',
              dateRange: '05/06/2021 - 05/06/2021',
              doctor: 'Dr Amanda Rodriguez'
            },
            {
              id: 2,
              type: 'Biopsy',
              status: 'Completed',
              statusColor: 'success',
              dateRange: '12/06/2021 - 12/06/2021',
              doctor: 'Dr Amanda Rodriguez'
            },
            {
              id: 3,
              type: 'Laser Treatment',
              status: 'In Progress',
              statusColor: 'warning',
              dateRange: '20/06/2021 - 30/08/2021',
              doctor: 'Dr Amanda Rodriguez'
            },
            {
              id: 4,
              type: 'Follow-up',
              status: 'Scheduled',
              statusColor: 'secondary',
              dateRange: '15/09/2021 - 15/09/2021',
              doctor: 'Dr Amanda Rodriguez'
            },
            {
              id: 5,
              type: 'Topical Treatment',
              status: 'In Progress',
              statusColor: 'success',
              dateRange: '01/07/2021 - 30/10/2021',
              doctor: 'Dr Amanda Rodriguez'
            },
            {
              id: 6,
              type: 'Final Assessment',
              status: 'Scheduled',
              statusColor: 'secondary',
              dateRange: '15/11/2021 - 15/11/2021',
              doctor: 'Dr Amanda Rodriguez'
            }
          ]
        }
  });

  // Efecto para cargar datos solo cuando sea necesario
  useEffect(() => {
    if (patientId) {
      loadData();
    }
  }, [patientId, loadData]);

  // Efecto para actualizar contador cuando cambian los tratamientos o la selección
  useEffect(() => {
    if (Object.keys(treatments).length > 0 && onCountUpdate) {
      // Contar el número de tipos de tratamiento disponibles (no los elementos del timeline)
      const treatmentTypesCount = Object.keys(treatments).length;
      
      onCountUpdate(componentName, treatmentTypesCount);
    }
  }, [treatments, onCountUpdate, componentName]);

  const getStatusBadgeClass = (statusColor) => {
    const classes = {
      warning: 'bg-warning text-dark',
      success: 'bg-success text-white',
      secondary: 'bg-secondary text-white'
    };
    return classes[statusColor] || 'bg-secondary text-white';
  };

  const currentTreatment = treatments[selectedTreatment];
  const currentCount = currentTreatment?.timeline?.length || 0;
  const treatmentTypesCount = Object.keys(treatments).length;

  if (loading) {
    return (
      <div className="p-4 bg-white h-100 rounded-10 shadow-sm">

        <h3 className="mb-3" style={{ fontSize: '1.125rem' }}>Treatment Timeline</h3>
       
          <div className="spinner-border spinner-border-sm me-2" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
          Cargando timeline de tratamientos...
        
      </div>
    );
  }

  if (!currentTreatment) {
    return (
      <div className="p-4 bg-white h-100 rounded-10 shadow-sm">

        <h3 className="mb-3" style={{ fontSize: '1.125rem' }}>Treatment Timeline</h3>
        
        <p className="text-muted">No hay datos de timeline disponibles</p>
        
      </div>
    );
  }

  return (
    <div className="p-4 bg-white h-100 rounded-10 shadow-sm">

      <h3 className="mb-3" style={{ fontSize: '1.125rem' }}>Treatment Timeline</h3>
      <div className="filter-container mb-4">
          <div className="row">
            {/* Select Input */}
              <div className="col-md-5 col-lg-6 d-none d-md-block mb-3 mb-md-0">
                <select 
                  className="form-select form-select-sm" 
                  style={{ width: 'auto', minWidth: '200px' }}
                  value={selectedTreatment}
                  onChange={(e) => setSelectedTreatment(e.target.value)}
                >
                  {Object.entries(treatments).map(([key, treatment]) => (
                    <option key={key} value={key}>
                      {treatment.name} ({treatment.timeline?.length || 0})
                    </option>
                  ))}
                </select>
              </div>

              <div className="col-md-7 col-lg-6 d-flex justify-content-end gap-1 gap-sm-2 flex-wrap">
                {/* Add New Button */}
                <button
                  className="btn btn-primary addnewbtn d-flex gap-2"
                  //onClick={handleAddNew}
                >
                  Add
                </button>
              </div>


          </div>
      </div>
      
      
      <div className="p-3">
        {currentTreatment.timeline?.length === 0 ? (
          <p className="text-muted">No hay tratamientos en el timeline</p>
        ) : (
          <div className="position-relative" style={{ paddingLeft: '40px' }}>
            {/* Timeline vertical line */}
            <div
              style={{
                position: 'absolute',
                left: '18px',
                top: '0',
                width: '4px',
                height: '100%',
                background: '#1976d2',
                borderRadius: '2px',
                zIndex: 0,
                opacity: 0.15
              }}
            ></div>
            {currentTreatment.timeline.map((item, index) => (
              <div
                key={item.id}
                className="d-flex align-items-start mb-4 position-relative"
                style={{ minHeight: '70px' }}
              >
                {/* Timeline number */}
                <div
                  className="d-flex align-items-center justify-content-center bg-white border border-primary text-primary rounded-8 fw-bold position-absolute"
                  style={{
                    left: '-42px',
                    top: '0',
                    width: '44px',
                    height: '44px',
                    fontSize: '18px',
                    zIndex: 2,
                    boxShadow: '0 2px 8px rgba(25, 118, 210, 0.08)'
                  }}
                >
                  {item.id}
                </div>
                {/* Timeline content */}
                <div className="ms-5 flex-grow-1">
                  <div className="fw-semibold text-dark mb-2">
                    {item.type}
                  </div>
                  <div className="d-flex flex-wrap gap-2 align-items-center">
                    <span
                      className={`badge rounded-pill px-3 py-2 fw-semibold`}
                      style={{
                        background:
                          item.statusColor === 'success'
                            ? '#e6f4ea'
                            : item.statusColor === 'warning'
                            ? '#fbeee6'
                            : '#e9ecef',
                        color:
                          item.statusColor === 'success'
                            ? '#34a853'
                            : item.statusColor === 'warning'
                            ? '#ea7d3a'
                            : '#6c757d',
                        fontSize: '15px'
                      }}
                    >
                      <span
                        className="me-1"
                        style={{
                          display: 'inline-block',
                          verticalAlign: 'middle'
                        }}
                      >
                        {item.statusColor === 'success' ? (
                          <span
                            style={{
                              display: 'inline-block',
                              width: '18px',
                              height: '18px',
                              background: '#34a853',
                              borderRadius: '50%',
                              textAlign: 'center',
                              color: '#fff',
                              //fontSize: '14px',
                              lineHeight: '18px'
                            }}
                          >
                            &#10003;
                          </span>
                        ) : (
                          <span
                            style={{
                              display: 'inline-block',
                              width: '18px',
                              height: '18px',
                              background: '#ea7d3a',
                              borderRadius: '50%',
                              textAlign: 'center',
                              color: '#fff',
                              //fontSize: '14px',
                              lineHeight: '18px'
                            }}
                          >
                            &#10003;
                          </span>
                        )}
                      </span>
                      {item.status}
                    </span>
                    <span
                      className="badge rounded-pill px-3 py-2"
                      style={{
                        background: '#e9ecef',
                        color: '#6c757d',
                        //fontSize: '15px'
                      }}
                    >
                      <span className="me-1 material-symbols-outlined" style={{ fontSize: '18px', verticalAlign: 'middle' }}>
                        calendar_today
                      </span>
                      {item.dateRange}
                    </span>
                    <span
                      className="badge rounded-pill px-3 py-2"
                      style={{
                        background: '#e9ecef',
                        color: '#6c757d',
                        //fontSize: '15px'
                      }}
                    >
                      <span className="me-1 material-symbols-outlined" style={{ fontSize: '18px', verticalAlign: 'middle' }}>
                        person
                      </span>
                      {item.doctor}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default TreatmentTimelineTreatments;